import { render, staticRenderFns } from "./stopwords.vue?vue&type=template&id=4b93a230"
import script from "./stopwords.vue?vue&type=script&lang=js"
export * from "./stopwords.vue?vue&type=script&lang=js"
import style0 from "./stopwords.vue?vue&type=style&index=0&id=4b93a230&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports